define('drops/dynamicGridLayout/dynamicGridLayout',[
    'jquery',
    'lq/drop',
    'lq/style'
], function ($, Drop, Style) {
    'use strict';

    var defaults = {
        data: {
            rows: [
                { value: 1, unit: 'fr' }
            ],
            columns: [
                { value: 1, unit: 'fr' }
            ],
            spaceBetweenRows: { value: 0, unit: 'px' },
            spaceBetweenColumns: { value: 0, unit: 'px' },
            isDynamiclySizedContainer: false,
            useDynamicWidth: false,
            useDynamicHeight: false
        }
    };

    function DynamicGridLayout(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.cellElements = [];

        this.initCellsVisibsWithVal(false);
        this.initDropsInCells();

        Style.renderStyles(this);

        return this;
    };

    Drop.extend(DynamicGridLayout, Drop);

    DynamicGridLayout.typeName = 'DynamicGridLayout';

    DynamicGridLayout.prototype.preRender = function () {
        this.piping.visibility.apply(this);

        // if the DynamicGridLayout is the only drop in a list item => switch to relative positioning
        if ((this.parent.data.type === 'ListItem' || (this.parent.data.type === 'ModalPopup' && this.parent.data.autoPosition)) && this.parent.childDrops.length === 1) {
            var elementCss = {
                position: 'relative'
            };

            var parentElementCss = {
            };

            if (this.data.useDynamicWidth) {
                elementCss.width = 'auto';
                parentElementCss.width = 'auto';
            }

            if (this.data.useDynamicHeight) {
                elementCss.height = 'auto';
                parentElementCss.height = 'auto';
            }

            this.$element.css(elementCss);
            this.parent.$element.css(parentElementCss);
        } else {
            this.applyPosition();
        }

        this.createCells();
    };

    DynamicGridLayout.prototype.render = function ($element) {
        return this.createAndRenderDrops($element);
    };

    DynamicGridLayout.prototype.postRender = function () {
        this.setupDynamicCells();
        this.setupCellsVisibilities();
        if (this.data.centered) {
            this.applyCentering();
        }
    };

    DynamicGridLayout.prototype.applyCentering = function () {
        this.$element.css({
            marginLeft: 'auto',
            marginRight: 'auto'
        });
        if (this.data.useDynamicWidth) {
            this.$element.css({
                width: 'fit-content'
            });
        }
    };

    DynamicGridLayout.prototype.createCells = function () {
        var self = this;
        this.cellElements = [];

        _.each(self.data.rows, function (row, rowIndex) {
            var rowElements = [];

            _.each(self.data.columns, function (column, columnIndex) {
                var $cellElement = self.easyCell(rowIndex, columnIndex);

                rowElements.push($cellElement);
            });

            self.cellElements.push(rowElements);
        });
    };

    DynamicGridLayout.prototype.easyCell = function (i, j) {
        var $cell = $('<div/>')
            .css({
                top: '',
                left: '',
                height: this.data.rows[i].unit === 'px' ? this.data.rows[i].value + 'px' : '',
                width: this.data.columns[j].unit === 'px' ? this.data.columns[j].value + 'px' : ''
            })
            .appendTo(this.$element);

        var isTopAndBottmAnchored =
            this.data.top !== undefined &&
            this.data.top !== null &&
            this.data.bottom !== undefined &&
            this.data.bottom !== null;

        var isLefAndRightAnchored =
            this.data.left !== undefined &&
            this.data.left !== null &&
            this.data.right !== undefined &&
            this.data.right !== null;

        if ((this.data.columns[j].unit === 'auto'|| this.data.columns[j].unit === 'fr') &&
            (this.data.rows[i].unit === 'auto' || this.data.rows[i].unit === 'fr') &&
            !this.data.useDynamicHeight &&
            !this.data.useDynamicWidth &&
            isTopAndBottmAnchored &&
            isLefAndRightAnchored) {
            $cell
                .css({
                    overflowY: 'auto',
                    overflowX: 'auto'
                });
        } else if ((this.data.rows[i].unit === 'auto' || this.data.rows[i].unit === 'fr') &&
            !this.data.useDynamicHeight &&
            isTopAndBottmAnchored &&
            ((this.data.columns[j].unit !== 'auto' || this.data.columns[j].unit !== 'fr') || this.data.useDynamicWidth)) {
            $cell
                .css({
                    overflowY: 'auto',
                    overflowX: 'hidden'
                });
        } else if ((this.data.columns[j].unit === 'auto' || this.data.columns[j].unit === 'fr') &&
            !this.data.useDynamicWidth &&
            isLefAndRightAnchored &&
            ((this.data.rows[i].unit !== 'auto' || this.data.rows[i].unit !== 'fr') || this.data.useDynamicHeight)) {
            $cell
                .css({
                    overflowY: 'hidden',
                    overflowX: 'auto'
                });
        }

        return $cell;
    };

    DynamicGridLayout.prototype.createRenderPromiseForChild = function (drop) {
        var $wrapper = this.getWrapperForDrop(drop);
        return drop.render($wrapper);
    };

    DynamicGridLayout.prototype.getWrapperForDrop = function (drop) {
        var cellElementData = this.getCellElementForChild(drop);
        var $cellElement = cellElementData.cellElement;
        var $wrapper = $cellElement.find('.grid-wrapper');
        if ($wrapper.length === 0) {
            $wrapper = $('<div class = "grid-wrapper"></div>')
                .css({
                    position: 'relative',
                    width: '100%',
                    height: '100%'
                });
            $wrapper.appendTo($cellElement);
        }

        var i = cellElementData.rowIndex;
        var j = cellElementData.columnIndex;

        this.dropsInCells[i][j].push(drop);

        if (drop.data.initialVisibility) {
            this.cellsContentVisibilities[i][j] = true;
        }

        drop.afterHidden = this.hideCellsIfNeeded.bind(this, i, j);
        drop.afterShown =  this.showCellsIfNeeded.bind(this, i, j);

        return $wrapper;
    };

    DynamicGridLayout.prototype.setupPosForDropInDynCell = function (drop) {
        var cellElementData = this.getCellElementForChild(drop);
        var $cellElement = cellElementData.cellElement;
        var $wrapper = $cellElement.children('.grid-wrapper');
        if (!$wrapper.length > 0)
            return;
        if (this.data.columns[cellElementData.columnIndex].unit === 'auto') {
            if (drop.data.left !== null && drop.data.left >= 0 && drop.data.right !== null && drop.data.right >= 0) {
                $($wrapper.parent()).css({
                    paddingLeft: drop.data.left + 'px',
                    paddingRight: drop.data.right + 'px'
                });

                drop.$element.css({
                    width: '100%'
                });
            } else if (drop.data.left !== null && drop.data.left >= 0) {
                $($wrapper.parent()).css({
                    paddingLeft: drop.data.left + 'px'
                });
            } else if (drop.data.right !== null && drop.data.right >= 0) {
                $($wrapper.parent()).css({
                    paddingRight: drop.data.right + 'px'
                });
            } else if (drop.data.useDynamicWidth || drop.data.autoWidth) {
                drop.$element.css({
                    width: 'auto'
                });
            }

            if (drop.data.top !== null && drop.data.top >= 0 && drop.data.bottom !== null && drop.data.bottom >= 0) {
                $wrapper.css({
                    boxSizing: 'border-box',
                    paddingTop: drop.data.top + 'px',
                    paddingBottom: drop.data.bottom + 'px'
                });

                drop.$element.css({
                    height: '100%'
                });
            } else if (drop.data.top !== null && drop.data.top >= 0) {
                $wrapper.css({
                    boxSizing: 'border-box',
                    paddingTop: drop.data.top + 'px'
                });
            } else if (drop.data.bottom !== null && drop.data.bottom >= 0) {
                $wrapper.css({
                    boxSizing: 'border-box',
                    paddingBottom: drop.data.bottom + 'px'
                });
            }

            if (!(drop.data.left !== null && drop.data.left >= 0) && drop.data.right !== null && drop.data.right >= 0) {
                $($wrapper.parent()).css({
                    marginLeft: 'auto'
                });
            }

            if (!(drop.data.top !== null && drop.data.top >= 0) && drop.data.bottom !== null && drop.data.bottom >= 0) {
                $($wrapper.parent()).css({
                    marginTop: 'auto'
                });
            }

            if (drop.data.centered) {
                $($wrapper.parent()).css({
                    marginTop: 'auto',
                    marginBottom: 'auto'
                });
            }
        }
        if (this.data.rows[cellElementData.rowIndex].unit === 'auto') {
            if (drop.data.top !== null && drop.data.top >= 0 && drop.data.bottom !== null && drop.data.bottom >= 0) {
                $($wrapper.parent()).css({
                    paddingTop: drop.data.top + 'px',
                    paddingBottom: drop.data.bottom + 'px'

                });

                drop.$element.css({
                    height: '100%'
                });
            } else if (drop.data.top !== null && drop.data.top >= 0) {
                $($wrapper.parent()).css({
                    paddingTop: drop.data.top + 'px'
                });
            } else if (drop.data.bottom !== null && drop.data.bottom >= 0) {
                $($wrapper.parent()).css({
                    paddingBottom: drop.data.bottom + 'px'
                });
            } else if (drop.data.useDynamicHeight || drop.data.autoHeight) {
                drop.$element.css({
                    height: 'auto'
                });
            }

            if (drop.data.left !== null && drop.data.left >= 0 && drop.data.right !== null && drop.data.right >= 0) {
                $wrapper.css({
                    boxSizing: 'border-box',
                    paddingLeft: drop.data.left + 'px',
                    paddingRight: drop.data.right + 'px'
                });

                drop.$element.css({
                    width: '100%'
                });
            } else if (drop.data.left !== null && drop.data.left >= 0) {
                $wrapper.css({
                    boxSizing: 'border-box',
                    paddingLeft: drop.data.left + 'px'
                });
            } else if (drop.data.right !== null && drop.data.right >= 0) {
                $wrapper.css({
                    boxSizing: 'border-box',
                    paddingRight: drop.data.right + 'px'
                });
            }

            if (!(drop.data.top !== null && drop.data.top >= 0) && drop.data.bottom !== null && drop.data.bottom >= 0) {
                $($wrapper.parent()).css({
                    marginTop: 'auto'
                });
            }

            if (!(drop.data.left !== null && drop.data.left >= 0) && drop.data.right !== null && drop.data.right >= 0) {
                $($wrapper.parent()).css({
                    marginLeft: 'auto'
                });
            }

            if (drop.data.centered) {
                $($wrapper.parent()).css({
                    marginLeft: 'auto',
                    marginRight: 'auto'
                });
            }
        }
    };

    DynamicGridLayout.prototype.applyPositionForChild = function (childDrop) {
        Drop.prototype.applyPositionForChild.call(this, childDrop);
        var cellElementData = this.getCellElementForChild(childDrop);
        if (this.data.columns[cellElementData.columnIndex].unit === 'auto' || this.data.rows[cellElementData.rowIndex].unit === 'auto') {
            if (childDrop.applyRelativePositioning)
                childDrop.applyRelativePositioning();
            childDrop.$element.css({
                position: 'relative',
                inset: ''
            });
            var margin = childDrop.data.margin;
            if (margin) {
                margin.top ? childDrop.$element.css({marginTop: margin.top + 'px'}) : childDrop.$element.css({marginTop: ''});
                margin.right ? childDrop.$element.css({marginRight: margin.right + 'px'}) : childDrop.$element.css({marginRight: ''});
                margin.bottom ? childDrop.$element.css({marginBottom: margin.bottom + 'px'}) : childDrop.$element.css({marginBottom: ''});
                margin.left ? childDrop.$element.css({marginLeft: margin.left + 'px'}) : childDrop.$element.css({marginLeft: ''});
            }
        }
        this.setupPosForDropInDynCell(childDrop);
    };

    DynamicGridLayout.prototype.getCellElementForChild = function (drop) {
        var rowIndex = Math.max(Math.min((drop.data.gridlayout_row || 1) - 1, this.data.rows.length - 1), 0);
        var columnIndex = Math.max(Math.min((drop.data.gridlayout_column || 1) - 1, this.data.columns.length - 1), 0);
        if (rowIndex === this.cellElements.length ) { // This part is needed, when nesting is happening, and cells don't exist yet
            var rowElements = [];
            var self = this;
            _.each(self.data.columns, function (column, columnIndexAll) {
                var $cellElement = self.easyCell(
                    rowIndex,
                    columnIndexAll);
                rowElements.push($cellElement);
            });
            this.cellElements.push(rowElements);
        }
        return {cellElement: this.cellElements[rowIndex][columnIndex], rowIndex: rowIndex, columnIndex: columnIndex};
    };

    DynamicGridLayout.prototype.getPropertyEditor = function (drop, editorName) {
        for (var key in drop.currentPropertyEditors) {
            for (var i = 0; i < drop.currentPropertyEditors[key].length; i++) {
                var propEditor = drop.currentPropertyEditors[key][i];
                if (propEditor.constructor.propertyEditorName === editorName) {
                    return propEditor;
                } else if (propEditor.constructor.propertyEditorName === 'CombinedEditor') {
                    for (var j = 0; j < propEditor.editors.length; j++) {
                        var propEditor2 = propEditor.editors[j];
                        if (propEditor2.constructor.propertyEditorName === editorName) {
                            return propEditor2;
                        }
                    }
                }
            }
        }
        return null;
    };

    DynamicGridLayout.prototype.setupDynamicCells = function () {
        if (this.data.useDynamicHeight || this.data.useDynamicWidth) {
            this.data.isDynamiclySizedContainer = true;
        }

        var gridTemplate = this.generateGridTemplate();

        this.$element.css({
            display: window.document.documentMode ? '-ms-grid' : 'grid',
            gridTemplateColumns: gridTemplate.gridTemplateColumns,
            gridTemplateRows: gridTemplate.gridTemplateRows,
            rowGap: this.data.spaceBetweenRows.value + this.data.spaceBetweenRows.unit,
            columnGap: this.data.spaceBetweenColumns.value + this.data.spaceBetweenColumns.unit
        });

        if (this.data.useDynamicHeight) {
            this.$element.css({
                height: ''
            });
        } else if (this.$element.css('height') === '') {
            this.$element.css({
                height: this.data.size.x + 'px'
            });
        }

        if (this.data.useDynamicWidth) {
            this.$element.css({
                width: ''
            });
        } else if (this.$element.css('width') === '') {
            this.$element.css({
                width: this.data.size.y + 'px'
            });
        }
    };

    DynamicGridLayout.prototype.generateGridTemplate = function () {
        var concat = function (first, second) {
            return first === '' ? second : first + ' ' + second;
        };

        var self = this;

        var gridTemplateRows = '';
        var gridTemplateColumns = '';

        for (var i = 0; i < this.cellsContentVisibilities.length; i++ ) {
            if (this.hasTrue(this.cellsContentVisibilities[i])) {
                switch (self.data.rows[i].unit) {
                    case 'auto':
                        gridTemplateRows = concat(gridTemplateRows, 'auto');
                        break;

                    case 'fr':
                        gridTemplateRows = concat(gridTemplateRows, self.data.rows[i].value + 'fr');
                        break;

                    case 'px':
                        gridTemplateRows = concat(gridTemplateRows, self.data.rows[i].value + 'px');
                        break;

                    default:
                        break;
                }
            }
        }

        for (var j = 0; j < this.data.columns.length; j++ ) {
            var columnArray = self.cellsContentVisibilities.map(function(v) { return v[j]; });
            if (this.hasTrue(columnArray)) {
                switch (self.data.columns[j].unit) {
                    case 'auto':
                        gridTemplateColumns = concat(gridTemplateColumns, 'auto');
                        break;

                    case 'fr':
                        gridTemplateColumns = concat(gridTemplateColumns, self.data.columns[j].value + 'fr');
                        break;

                    case 'px':
                        gridTemplateColumns = concat(gridTemplateColumns, self.data.columns[j].value + 'px');
                        break;

                    default:
                        break;
                }
            }
        }

        return {
            gridTemplateRows,
            gridTemplateColumns
        };
    };

    DynamicGridLayout.prototype.isAllFalse = function (array) {
        return _.every(array, function (a) { return !a} );
    };

    DynamicGridLayout.prototype.hasTrue = function (array) {
        return !this.isAllFalse(array);
    };

    DynamicGridLayout.prototype.hideCellsIfNeeded = function (i, j) {
        if (_.all(this.dropsInCells[i][j], function (d) {
            return d.isHidden;
        })) {
            this.cellsContentVisibilities[i][j] = false;

            var columnArray = this.cellsContentVisibilities.map(function(v) { return v[j]; });
            if (this.isAllFalse(this.cellsContentVisibilities[i])) {
                for (var k = 0; k < this.cellsContentVisibilities[i].length; k++) {
                    this.cellElements[i][k].hide();
                }
                this.$element.css('grid-template-rows', this.generateGridTemplate().gridTemplateRows);
            }

            if (this.isAllFalse(columnArray)) {
                for (var k = 0; k < columnArray.length; k++) {
                    this.cellElements[k][j].hide();
                }
                this.$element.css('grid-template-columns', this.generateGridTemplate().gridTemplateColumns);
            }
        }
    };

    DynamicGridLayout.prototype.showCellsIfNeeded = function (i, j) {
        this.cellsContentVisibilities[i][j] = true;
        this.setupCellsVisibilities();
    };

    DynamicGridLayout.prototype.setupCellsVisibilities = function () {
        for (var i = 0; i < this.cellsContentVisibilities.length; i++) {
            for (var j = 0; j < this.cellsContentVisibilities[i].length; j++) {
                if (!this.cellsContentVisibilities[i][j]) {
                   var columnArray = this.cellsContentVisibilities.map(function(v) { return v[j]; });
                    if (this.isAllFalse(this.cellsContentVisibilities[i]) || this.isAllFalse(columnArray)) {
                        this.cellElements[i][j].hide();
                    } else {
                        this.cellElements[i][j].show();
                    }
                } else {
                    this.cellElements[i][j].show();
                }
            }
        }

        var gridTemplate = this.generateGridTemplate();

        this.$element.css('grid-template-rows', gridTemplate.gridTemplateRows);
        this.$element.css('grid-template-columns', gridTemplate.gridTemplateColumns);
    };

    DynamicGridLayout.prototype.initCellsVisibsWithVal = function (val) {
        const R = this.data.rows.length;
        const C = this.data.columns.length;

        this.cellsContentVisibilities = Array(R);
        for (var i = 0; i < R; i++) {
            this.cellsContentVisibilities[i] = Array(C).fill(val || false);
        }
    };

    // We store the actual drop objects in a two dimensional array structure
    // that represents the Dynamic Grid Layout
    DynamicGridLayout.prototype.initDropsInCells = function () {
        const R = this.data.rows.length;
        const C = this.data.columns.length;
        this.dropsInCells = [];

        for (var i = 0; i < R; i++) {
            this.dropsInCells.push([]);

            for (var j = 0; j < C; j++) {
            // Fill each element with an empty array
                this.dropsInCells[i].push([]);
            }
        }
    };

    DynamicGridLayout.prototype.reInitDropsInCells = function () {
        this.initDropsInCells();
    };

    return DynamicGridLayout;
});

